/* =============================================
   Related Products — Swiper Init
   File: assets/related-products.js

   Fixes:
   1. Nav buttons passed as direct DOM element references
      (not NodeList) so Swiper can attach listeners properly.
   2. watchOverflow: true prevents the "Cannot read properties
      of undefined (reading 'remove')" error when slide count
      is less than or equal to slidesPerView — Swiper disables
      itself cleanly instead of trying to clone missing slides.
   ============================================= */

(function () {

  function buildSwiperConfig(section, prevBtn, nextBtn) {
    const autoplay      = section.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 3000;
    const loop          = section.dataset.loop === 'true';
    const slidesDesktop = parseInt(section.dataset.slidesDesktop, 10) || 3;
    const slidesTablet  = parseInt(section.dataset.slidesTablet, 10)  || 2;

    const config = {
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      loop: loop,

      /* Prevents the "remove" crash when there are fewer slides
         than slidesPerView — Swiper just disables instead */
      watchOverflow: true,

      a11y: {
        prevSlideMessage: 'Previous product',
        nextSlideMessage: 'Next product',
      },

      /* Pass actual DOM elements, not a NodeList or selector string.
         Swiper requires a single element reference for each button. */
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'swiper-button-disabled',
      },

      breakpoints: {
        641: {
          slidesPerView: slidesTablet,
          spaceBetween: 24,
        },
        1025: {
          slidesPerView: slidesDesktop,
          spaceBetween: 28,
        },
      },
    };

    if (autoplay) {
      config.autoplay = {
        delay: autoplaySpeed,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      };
    }

    return config;
  }

  function initSwiper(section) {
    const swiperEl = section.querySelector('.rp-swiper');
    if (!swiperEl) return;

    /* Avoid double-init */
    if (swiperEl.swiper) return;

    /* There are two sets of buttons in the DOM:
       - One inside .related-products__header (shown on mobile via CSS)
       - One inside .rp-swiper (floating, shown on desktop)
       We grab both and pass them as arrays — Swiper accepts arrays of elements. */
    const prevBtns = Array.from(section.querySelectorAll('.rp-btn-prev'));
    const nextBtns = Array.from(section.querySelectorAll('.rp-btn-next'));

    /* Use array if multiple, single element if only one */
    const prevEl = prevBtns.length === 1 ? prevBtns[0] : prevBtns;
    const nextEl = nextBtns.length === 1 ? nextBtns[0] : nextBtns;

    new Swiper(swiperEl, buildSwiperConfig(section, prevEl, nextEl));
  }

  function watchForRecommendations(section) {
    const productRec = section.querySelector('product-recommendations');
    if (!productRec) return;

    /* Already injected (e.g. browser cache) */
    if (section.querySelector('.rp-swiper')) {
      initSwiper(section);
      return;
    }

    /* Watch for Dawn's async HTML injection */
    const observer = new MutationObserver(function (mutations, obs) {
      if (section.querySelector('.rp-swiper')) {
        obs.disconnect();
        initSwiper(section);
      }
    });

    observer.observe(productRec, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('.related-products').forEach(watchForRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();